import { useState, useEffect } from "react";
import { Typography } from "antd";

const { Paragraph, Text } = Typography;

export default function TypingText({
  text,
  screenWidth,
  typingSpeed = 150,
  deletingSpeed = 100,
  pauseTime = 1000,
}) {
  const [displayedText, setDisplayedText] = useState(""); // The displayed portion of the text
  const [isDeleting, setIsDeleting] = useState(false); // Whether it's deleting or typing
  const [index, setIndex] = useState(0); // The index of the current character in the text
  const [speed, setSpeed] = useState(typingSpeed); // Speed can change between typing and deleting

  useEffect(() => {
    let timeout;

    const updateText = () => {
      // If typing and not done typing
      if (!isDeleting && index < text.length) {
        setDisplayedText(text.slice(0, index + 1)); // Add one character
        setIndex(index + 1); // Move to next character
      }

      // If deleting and not done deleting
      else if (isDeleting && index > 0) {
        setDisplayedText(text.slice(0, index - 1)); // Remove one character
        setIndex(index - 1); // Move back one character
      }

      // If typing is finished, start deleting after pauseTime
      if (index === text.length && !isDeleting) {
        timeout = setTimeout(() => setIsDeleting(true), pauseTime); // Start deleting after pause
        setSpeed(deletingSpeed); // Switch to deleting speed
      }

      // If deleting is finished, start typing again after pauseTime
      else if (isDeleting && index === 0) {
        timeout = setTimeout(() => setIsDeleting(false), pauseTime); // Start typing after pause
        setSpeed(typingSpeed); // Switch back to typing speed
      }
    };

    timeout = setTimeout(updateText, speed);

    // Clean up the timeout on component unmount
    return () => clearTimeout(timeout);
  }, [text, index, isDeleting, speed, typingSpeed, deletingSpeed, pauseTime]);

  return (
    <Paragraph
      style={{
        margin: 0,
        wordWrap: "break-word",
        whiteSpace: "normal",
        height: "5vh",
        lineHeight: 1,
        fontSize: screenWidth < 800 ? "1rem" : "1.5rem",
      }}
      strong
    >
      {displayedText}
      <Text className="cursor">...</Text>
    </Paragraph>
  );
}
